import React, { useState } from "react";
import { NavLink as RRNavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderLanding from "./../Layout/HeaderLanding";
import { loginUser } from "../../redux/slices/userSlice";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const Signin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.user);

  const [form, setForm] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginUser(form));
    if (loginUser.fulfilled.match(result)) {
      const resultConfirm = await Swal.fire({
        title: "Terms of Service (Internal Testing Phase)",
        html: `By participating in the internal testing of <b>MIRACLE PACE INC.</b>’s peer-to-peer currency exchange platform, you agree to use the service for testing purposes only. You may not share access or engage in unauthorized activities. We comply with Canadian regulations, including FINTRAC requirements. A full Terms of Service will be available upon public launch.`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "I Agree",
        cancelButtonText: "I Don't Agree",
        customClass: {
          popup: "text-left",
        },
      });

      if (resultConfirm.isConfirmed) {
        navigate("/home");
      } else {
        Swal.fire({
          icon: "warning",
          title: "Access Denied",
          text: "You must accept the Terms of Service to proceed.",
        });
      }
    }
  };

  return (
    <div>
      <HeaderLanding />
      <div className="authincation section-padding">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-xl-4 col-md-6">
              <div className="auth-form card">
                <div className="card-header justify-content-center">
                  <h4 className="card-title">{t("signIn.label")}</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label>{t("email.label")}</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="hello@example.com"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>{t("password.label")}</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder={t("password.label")}
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                    <div className="form-row d-flex justify-content-between mt-4 mb-2">
                      <div className="form-group mb-0">
                        <label className="toggle">
                          <input className="toggle-checkbox" type="checkbox" />
                          <div className="toggle-switch"></div>
                          <span className="toggle-label">
                            {t("remember.me.label")}
                          </span>
                        </label>
                      </div>
                      <div className="form-group mb-0">
                        <RRNavLink to="/reset" className="text-muted">
                          {t("password.forget.label")}
                        </RRNavLink>
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-success btn-block"
                        disabled={loading}
                      >
                        {loading ? "Signing in..." : t("signIn.label")}
                      </button>
                    </div>
                  </form>
                  <div className="new-account mt-3">
                    <p>
                      {t("dont.have.account.label")}{" "}
                      <RRNavLink to="/signup" className="text-primary">
                        {t("signUp.label")}
                      </RRNavLink>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg_icons"></div>
    </div>
  );
};

export default Signin;
